<template>
  <div class="players">
    <div class="mb-4 ">

      <div v-for="(player, index) of players" class=" flex py-1  " :key="index">
        <ModalColorPicker
          @selectedColor="player.color = $event"
          :initialColor="player.color"
          :selectedColor="player.color"
          :pickedColor="player.color"
          :pickerTitle="player.name"
        />

        <div class="ml-2 flex-grow">
          <input
            name="color"
            class="input-text"
            v-model="player.name"
            placeholder="Nom"
          />
        </div>

        <ClassicButton
          v-if="players.length > 1"
          classButton="text-sm trashButton"
          flexOption=""
          @buttonClick="
            deletePlayer(index);
            $emit('removePlayer', player.name);
          "
        >
          <template v-slot:ButtonContent>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              class="svg size-6 "
            >
              <path
                d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z"
              ></path>
            </svg>
          </template>
        </ClassicButton>
      </div>

    </div>
          <FormPlayer @newPlayer="addPlayer($event)" />

  </div>
</template>

<script>
// @ is an alias to /src
import FormPlayer from "@/components/ui/form/FormPlayer.vue";
import ModalColorPicker from "@/components/ui/custom/ModalColorPicker.vue";
import ClassicButton from "@/components/ui/form/button/ClassicButton.vue";

export default {
  name: "gamers",
  props: {
    players: {
      type: Array,
      required: true,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      ONplayers: [],
      newplayer: null
    };
  },
  components: {
    FormPlayer,
    ModalColorPicker,
    ClassicButton
  },
  methods: {
    addPlayer: function(event) {
      //this.player.current = event;
      //this.newplayer = event;
      this.players.push(event);
      //this.$emit("newPlayer", event);
      //this.$emit("currentPlayers", this.players);
    },
    updatePlayer: function(index, name) {
      if (name != "") {
        this.players[index].name = name.toLowerCase();
      } else {
        this.players.splice(index, 1);
      }
      // this.$emit("currentPlayers", this.players);
    },
    deletePlayer: function(index) {
      this.players.splice(index, 1);
      //this.$emit("currentPlayers", this.players);
    }
  },
  watch: {
    players: {
      handler() {
        this.$emit("currentPlayers", this.players);
      },
      deep: true
    }
  },
  mounted() {}
};
</script>
